import { render, staticRenderFns } from "./OnlineCustomTabs.vue?vue&type=template&id=ab99574c&scoped=true&"
import script from "./OnlineCustomTabs.vue?vue&type=script&lang=js&"
export * from "./OnlineCustomTabs.vue?vue&type=script&lang=js&"
import style0 from "./OnlineCustomTabs.vue?vue&type=style&index=0&id=ab99574c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab99574c",
  null
  
)

export default component.exports